import React, { useEffect, useState } from "react";
import leftPng from "../../../../../content/images/left.png";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import NumberFormat from "react-number-format";
import { wait } from "@testing-library/react";

class Bewerkprijsperuitvoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableArray: [],
      uitvoerder: "",
      procentueel: "",
      nieuwbedrag: "",
      vastbedrag: "",
      uitvoerderSelect: [],
      createState: false,
      createButtonState: false,
      editButtonState: false,
      uitvoerderText: "",
      uitvoerderId: "",
      activeIndexId: "",
      activeIndex: false,
      activityIdentification: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
  }
  trCount = 1;

  handleEvent() {
    // this.state = {
    //   tableArray: this.state.tableArray,
    //   uitvoerder: this.state.uitvoerder,
    //   procentueel: this.state.procentueel,
    //   nieuwbedrag: this.state.nieuwbedrag,
    //   uitvoerderSelect: this.state.uitvoerderSelect,
    // };
  }
  handleInputChange = (event) => {
    const re = /^[0-9\b]+$/;
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (
      event.target.value === "" ||
      re.test(event.target.value) ||
      name == "uitvoerder"
    ) {
      this.setState({
        [name]: value,
      });

      if (name == "uitvoerder") {
        var index = event.nativeEvent.target.selectedIndex;
        var test = event.nativeEvent.target[index].text;
        this.setState({ uitvoerderText: event.nativeEvent.target[index].text });
      }
    }
  };

  async handleSubmit() {
    $("#cover-spin").show(0);

    var model = {
      prijsperuitvoerder: [],
    };
    this.state.tableArray.forEach((element) => {
      var tempModel = {
        prijsperuitvoerder: [
          {
            uitvoerder: {
              display: [
                {
                  path: "$.name",
                  value: element.uitvoerder.display[0].value,
                },
              ],
              identification: element.uitvoerder.identification,
            },
            vastbedrag: Number(element.vastbedrag),
            nieuwbedrag: Number(element.nieuwbedrag),
            procentueel: Number(element.procentueel),
          },
        ],
        uitvoerder: {
          identification: process.env.REACT_APP_BEWERKPRIJSPERUITVOERDER, //"ddc702be-868a-45da-8f09-5e4f083240f6",
          display: [
            { path: "$.name", value: element.uitvoerder.display[0].value },
          ],
        },
        vastbedrag: Number(element.vastbedrag),
        nieuwbedrag: Number(element.nieuwbedrag),
        procentueel: Number(element.procentueel),
      };
      model.prijsperuitvoerder.push(tempModel);
    });
    // model.forEach((element) => {
    //   delete element.sort;
    // });

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "0b9704cf-9838-4361-b79b-5e81a5337114",
      this.SavedCallBack,
      window.$catalog_management_units_token
    );

    // let inputDataResult = await omnimap.InputdataPostAction(
    //   model,
    //   this.state.activityIdentification,
    //   window.$catalog_management_units_token
    // );

    // let validateResult = await omnimap.ValidatePostAction(
    //   this.state.activityIdentification,
    //   window.$catalog_management_units_token
    // );
  }

  SavedCallBack() {
    GC.sleep(500).then(() => {
      $("#bewerk_prijs_per_uitvoerder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }

  async GetDetail(params) {
    $("#cover-spin").show(0);
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    let stageResult = await omnimap.GetActionsOfRowSingleAction(
      window.$catalog_measures_selected_ids[0],
      window.$catalog_management_units_token
    );

    let definition = stageResult.data.stages_list.filter(
      (def) => def.definition["name"] === "Bewerk prijs per uitvoerder"
    );
    var result = await omnimap.GetRowOfActionDetailStartAction(
      window.$catalog_measures_selected_ids[0],
      definition[0].identification,
      window.$catalog_management_units_token
    );
    this.setState({
      activityIdentification: result.data.activity_identification,
    });

    // if (result.data.activity_identification === undefined) {
    //   var model = {};
    //   let resultStart = await omnimap.StartActionActivityAction(
    //     model,
    //     selectedIds,
    //     result.data.identification,
    //     window.$catalog_management_units_token
    //   );
    // }

    if (
      result.data.activity_identification &&
      result.data.activity_identification !== undefined
    ) {
      omnimap
        .GetRowOfActionDetailPostAction(
          result.data.activity_identification,
          window.$catalog_management_units_token
        )
        .then((result) => {
          result.data.prijsperuitvoerder.forEach((element) => {
            element.sort = this.trCount++;
          });
          this.setState({
            tableArray: result.data.prijsperuitvoerder,
          });
        });
    } else {
      this.setState({
        tableArray: [],
      });
    }

    var model = { definitions: [process.env.REACT_APP_UITVOERDER] };

    model = {
      "content":[
        {
          "key":"algemeen-isuitvoerder",
          "and_or":"AND",
          "values":[
            true
          ],
          "datatype":"BOOLEAN"
        },
        {
          "key":"algemeen-actief",
          "and_or":"AND",
          "values":[

          ],
          "datatype":"BOOLEAN"
        }
      ],
      "definitions":[
        //"84a38236-5bdb-477e-b506-3c0ea2cb7f65"
        process.env.REACT_APP_USER_ORGANISATION
      ]
    }

    var selectResult = await omnimap.FillTableAction(
      model,
      1,
      window.$catalog_management_units_token
    );
    this.setState({ uitvoerderSelect: selectResult.data });
    $("#cover-spin").hide(0);
  }

  addUitTable() {
    this.setState({
      createState: !this.state.createState,
      createButtonState: !this.state.createButtonState,
    });
  }
  backTable() {
    this.setState({
      createState: !this.state.createState,
      createButtonState: false,
      editButtonState: false,
    });
  }

  async addUit() {
    var model = {
      uitvoerder: {
        display: [
          {
            path: "$.name",
            value: this.state.uitvoerderText,
          },
        ],
        identification: this.state.uitvoerder,
      },
      vastbedrag: this.state.vastbedrag,
      nieuwbedrag: this.state.nieuwbedrag,
      procentueel: this.state.procentueel,
      sort: this.state.activeIndex ? this.state.activeIndexId : this.trCount++,
    };

    // Create a new array based on current state:
    let newList = [...this.state.tableArray];

    // Add item to it
    newList.push(model);

    // Set state
    await this.setState({
      tableArray: newList,
      createState: false,
      createButtonState: false,
    });
  }

  editUit(rowId) {
    const stage = this.state.tableArray.filter((row) => row.sort === rowId)[0];
    this.setState({
      uitvoerder: stage.uitvoerder.identification,
      uitvoerderText: stage.uitvoerder.display[0].value,
      procentueel: stage.procentueel,
      nieuwbedrag: stage.nieuwbedrag,
      vastbedrag: stage.vastbedrag,
      createState: true,
      createButtonState: false,
      editButtonState: true,
      activeIndexId: rowId,
    });
  }
  async editUitSave() {
    await this.remove(this.state.activeIndexId);
    await this.setState({ activeIndex: true });
    await this.addUit();
    await this.setState({ activeIndex: false, editButtonState: false });
  }
  remove(rowId) {
    // Array.prototype.filter returns new array
    // so we aren't mutating state here
    const arrayCopy = this.state.tableArray.filter((row) => row.sort !== rowId);
    this.setState({ tableArray: arrayCopy });
    // this.setState({ data: arrayCopy });
  }

  componentDidMount() {
    var that = this;
    $("#bewerk_prijs_per_uitvoerder").on("show.bs.modal", function (event) {
      that.GetDetail();
    });
  }

  render() {
    this.handleEvent();
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="bewerk_prijs_per_uitvoerder"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bewerk prijs per uitvoerder</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <input type="search" className="modal-search" placeholder="" />
              <div className="modal-scroll">
                <table
                  class="table table-striped"
                  hidden={this.state.createState ? true : false}
                >
                  <thead>
                    <tr>
                      <th scope="col">Uitvoerder</th>
                      <th scope="col">Procentueel</th>
                      <th scope="col">Vastbedrag</th>
                      <th scope="col">Nieuwbedrag</th>
                      <th scope="col" class="text-right">
                        <a
                          href="javascript:void(0)"
                          className="addStageList"
                          onClick={this.addUitTable.bind(this)}
                        ></a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tableArray
                      .sort(
                        ({ sort: previousID }, { sort: currentID }) =>
                          previousID - currentID
                      )
                      .map((row) => (
                        <tr id={row.sort}>
                          <td>{row.uitvoerder.display[0].value}</td>
                          <td>{row.procentueel}</td>
                          <td>
                            <NumberFormat
                              value={row.vastbedrag}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"€ "}
                            />
                          </td>
                          <td>€ {row.nieuwbedrag}</td>
                          <td>
                            <div class="btn-group" role="group">
                              <a
                                id=""
                                class="button-modal-table bewerken"
                                onClick={() => this.editUit(row.sort)}
                              ></a>
                              {"\u00A0"}
                              <a
                                class="button-modal-table delete"
                                id=""
                                onClick={() => this.remove(row.sort)}
                              ></a>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <div hidden={this.state.createState ? false : true}>
                  <div className="float-right mt-4">
                    <a
                      id="detail-button"
                      className="back-page-link back-page-link-modal"
                      role="button"
                      onClick={this.backTable.bind(this)}
                    >
                      <img className="" src={leftPng} width={9} height={12} />{" "}
                      &nbsp;Terug naar
                    </a>
                  </div>
                  <br />
                  <label>Uitvoerder</label>
                  <select
                    className="form-control"
                    id="maatregelen-kwaliteit"
                    name="uitvoerder"
                    value={this.state.uitvoerder}
                    onChange={this.handleInputChange}
                  >
                    {this.state.uitvoerderSelect? this.state.uitvoerderSelect.map((option) => (
                      <option
                        key={option.identification}
                        value={option.identification}
                      >
                        {option.name}
                      </option>
                    )):false}
                  </select>
                  <label>Procentueel</label>
                  <input
                    id="maatregelen-code"
                    type="input"
                    className="form-control"
                    name="procentueel"
                    value={this.state.procentueel}
                    onChange={this.handleInputChange}
                    autocomplete="off"
                  />
                  <label>Vastbedrag</label>
                  <input
                    id="maatregelen-code"
                    type="input"
                    className="form-control"
                    name="vastbedrag"
                    value={this.state.vastbedrag}
                    onChange={this.handleInputChange}
                    autocomplete="off"
                  />
                  <label>Nieuwbedrag</label>
                  <input
                    id="maatregelen-code"
                    type="input"
                    className="form-control"
                    name="nieuwbedrag"
                    value={this.state.nieuwbedrag}
                    onChange={this.handleInputChange}
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="bewerk_prijs_per_uitvoerder_save"
                className="btn-modal"
                hidden={this.state.createState ? true : false}
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
              <button
                type="button"
                id="bewerk_prijs_per_uitvoerder_save"
                className="btn-modal"
                hidden={this.state.createButtonState ? false : true}
                onClick={this.addUit.bind(this)}
              >
                toevoegen
              </button>
              <button
                type="button"
                id="bewerk_prijs_per_uitvoerder_save"
                className="btn-modal"
                hidden={this.state.editButtonState ? false : true}
                onClick={this.editUitSave.bind(this)}
              >
                bewerk
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Bewerkprijsperuitvoerder;
